// extracted by mini-css-extract-plugin
module.exports = {"hidden":"notice_hidden__3lNk7","textEmphasis":"notice_textEmphasis__FRdsR","noticeArea":"notice_noticeArea__asFsi","title":"notice_title__TanIT","message":"notice_message__IJg_c"};